var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var _a, _b;
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { Subject } from '@/models/Subject';
import TopicRow from '@/components/topic-row/TopicRow';
import NewSubjectDialog from '@/views/Subjects/Dialogs/NewSubjectDialog';
import { Model } from '@/models/Model';
import { blackKidIcons, blackAreaIcons, whiteAreaIcons, whiteKidIcons } from '@/support/Icon';
import ErrorHandler from '@/support/ErrorHandler';
import Storage from '@/support/Storage';
import { excludeRoles } from '@/support/ExcludeRoles';
import { Curriculum } from '@/models/Curriculum';
import { RolesEnum } from '@/items/Roles';
import StatusSetSelect from '@/components/StatusSetSelect/StatusSetSelect.vue';
let AreaRow = class AreaRow extends Vue {
    constructor() {
        super(...arguments);
        this.visible = {
            actions: true,
            checkboxes: false,
        };
        this.areaCountData = null;
        this.countData = [];
        this.countDataSubjects = 0;
        this.selectedStatusSet = null;
        this.topics = [];
        this.subjects = [];
        this.newSubjectDialog = false;
        this.newSubject = null;
        this.editing = false;
        this.orginalName = '';
        this.selectedAreaColor = '';
        this.selectedAreaIcon = '';
        this.areaColors = [
            '#D0011B',
            '#F6A623',
            '#F8E81C',
            '#7ED321',
            '#417505',
            '#BD0FE1',
            '#9012FE',
            '#4990E2',
            '#50E3C2',
            '#9B9B9B',
        ];
        this.selectedArea = null;
        this.isIdpEligible = null;
        this.ignoreStatusDuringPeriodChange = null;
        this.isFetchingAreaCount = false;
        this.hasAreaCount = false;
        this.selectedTopics = [];
    }
    get excludeOptions() {
        const area = this.selectedArea;
        const isIdpEligible = this.isIdpEligible;
        return {
            title: area.name || this.$t('dialogOptions.confirmation').toString(),
            text: isIdpEligible
                ? this.$t('curriculum.area.include.message').toString()
                : this.$t('curriculum.area.exclude.message').toString(),
            type: 'warning',
            buttons: {
                confirm: {
                    text: isIdpEligible
                        ? this.$t('curriculum.area.include.button').toString()
                        : this.$t('curriculum.area.exclude .button').toString(),
                    action: () => {
                        if (!area) {
                            return;
                        }
                        area
                            .update({ is_idp_eligible: isIdpEligible })
                            .then((updatedArea) => {
                            this.editing = false;
                            this.resetTemporaryVars();
                            this.$emit('area-update', updatedArea);
                        })
                            .catch((error) => {
                            area.name = this.orginalName;
                            this.resetTemporaryVars();
                            ErrorHandler.network(error);
                        });
                    },
                },
                cancel: {
                    text: this.$t('dialogOptions.button.cancel').toString(),
                    action: () => {
                        this.selectedArea = null;
                    },
                },
            },
        };
    }
    get IgnoreStatusDuringPeriodChangeOptions() {
        const area = this.selectedArea;
        const ignoreStatusDuringPeriodChange = this.ignoreStatusDuringPeriodChange;
        return {
            title: area.name || this.$t('dialogOptions.confirmation').toString(),
            text: ignoreStatusDuringPeriodChange
                ? this.$t('curriculum.area.periodChange.ignoreStatus.message').toString()
                : this.$t('curriculum.area.periodChange.updateStatus.message').toString(),
            type: 'warning',
            buttons: {
                confirm: {
                    text: ignoreStatusDuringPeriodChange
                        ? this.$t('curriculum.area.periodChange.ignoreStatus.button').toString()
                        : this.$t('curriculum.area.periodChange.updateStatus.button').toString(),
                    action: () => {
                        if (!area) {
                            return;
                        }
                        area
                            .update({ ignore_status_during_period_change: ignoreStatusDuringPeriodChange })
                            .then((updatedArea) => {
                            this.editing = false;
                            this.resetTemporaryVars();
                            this.$emit('area-update', updatedArea);
                        })
                            .catch((error) => {
                            area.name = this.orginalName;
                            this.resetTemporaryVars();
                            ErrorHandler.network(error);
                        });
                    },
                },
                cancel: {
                    text: this.$t('dialogOptions.button.cancel').toString(),
                    action: () => {
                        this.selectedArea = null;
                    },
                },
            },
        };
    }
    get worksheetGenerationDialogOptions() {
        const subject = this.area;
        const isWorksheetEnabled = this.area.has_generated_worksheets;
        return {
            title: subject.name || this.$t('dialogOptions.confirmation').toString(),
            text: this.$t('curriculum.area.enableWorksheet.message').toString(),
            type: 'warning',
            buttons: {
                confirm: {
                    text: isWorksheetEnabled
                        ? this.$t('curriculum.area.enableWorksheet.disable').toString()
                        : this.$t('curriculum.area.enableWorksheet.enable').toString(),
                    action: () => {
                        if (!subject) {
                            return;
                        }
                        subject
                            .update({ has_generated_worksheets: !isWorksheetEnabled })
                            .then((updatedSubject) => {
                            subject.has_generated_worksheets = updatedSubject.has_generated_worksheets;
                        })
                            .catch((error) => {
                            ErrorHandler.network(error);
                        });
                    },
                },
                cancel: {
                    text: this.$t('curriculum.area.enableWorksheet.cancel').toString(),
                },
            },
        };
    }
    get dialogOptions() {
        const area = this.selectedArea;
        return {
            title: area.name || this.$t('dialogOptions.confirmation').toString(),
            text: this.$tc('dialogOptions.delete', 2, {
                item: this.$t('dialogOptions.item.area'),
            }).toString(),
            type: 'warning',
            buttons: {
                confirm: {
                    text: this.$t('dialogOptions.button.delete').toString(),
                    action: () => {
                        if (!area) {
                            return;
                        }
                        area
                            .delete()
                            .then(() => {
                            this.editing = false;
                            this.resetTemporaryVars();
                            this.$emit('area-deleted', { area });
                        })
                            .catch((error) => {
                            area.name = this.orginalName;
                            this.resetTemporaryVars();
                            ErrorHandler.network(error);
                        });
                    },
                },
                cancel: {
                    text: this.$t('dialogOptions.button.cancel').toString(),
                    action: () => {
                        this.selectedArea = null;
                    },
                },
            },
        };
    }
    get blackIcons() {
        const type = Storage.get('type');
        return type && type.toLowerCase() === 'po' ? blackAreaIcons : blackKidIcons;
    }
    get whiteIcons() {
        const type = Storage.get('type');
        return type && type.toLowerCase() === 'po' ? whiteAreaIcons : whiteKidIcons;
    }
    get exclude() {
        return excludeRoles[this.$store.state.version].curriculum.subject.includes(this.$store.state.Auth.roles[0].id);
    }
    mounted() {
        this.selectedAreaIcon = this.area.icon || '';
        this.selectedAreaColor = this.area.color || '';
        this.selectedStatusSet =
            this.area && this.area.label_group ? this.area.label_group : null;
        this.visible = { ...{}, ...this.visible, ...this.visibility };
        if (Array.isArray(this.area.children)) {
            this.topics = new Model().dataToModel({}, 'Subject', this.area.children);
        }
    }
    onSelectedSubjectsChanged(subjects) {
        this.$emit('selectedSubjectsChanged', subjects);
    }
    onSelectedTopicChanged(topic, isSelected) {
        if (isSelected) {
            this.selectedTopics.push(topic);
        }
        else {
            this.selectedTopics = this.selectedTopics.filter((selectedTopic) => selectedTopic.id !== topic.id);
        }
        this.$emit('selectedTopicsChanged', this.selectedTopics);
    }
    isTopicSelected(topic) {
        return false;
        // return this.selectedTopics.some((t) => t.id === topic.id);
    }
    getAreaStatusSet() {
        let statusSet = null;
        if (this.selectedStatusSet) {
            statusSet = this.selectedStatusSet;
        }
        else {
            statusSet = this.area.label_group;
        }
        switch (statusSet.name) {
            case 'Default':
                return this.$tc('Default');
            default:
                return statusSet.name;
        }
    }
    onEyeClicked(topic) {
        if (!topic.id) {
            return;
        }
        const routeBase = {
            params: { subjectid: topic.id },
            query: {
                topic: topic.id,
                area: this.area.id,
                ...(this.$route.query && this.$route.query.levels
                    ? { levels: this.$route.query.levels }
                    : {}),
                ...(this.$route.query && this.$route.query.periods
                    ? { periods: this.$route.query.periods }
                    : {}),
                ...(this.$route.query && this.$route.query.statuses
                    ? { statuses: this.$route.query.statuses }
                    : {}),
            },
        };
        this.$router.push({
            ...routeBase,
            name: 'subject-overview.index',
            query: {
                ...routeBase.query,
            },
        });
    }
    updateArea(area) {
        area.color = this.selectedAreaColor;
        try {
            area.update({
                name: area.name,
                label_group: this.selectedStatusSet ? this.selectedStatusSet.id : null,
                color: this.selectedAreaColor || null,
                icon: this.selectedAreaIcon || null,
            });
            this.editing = false;
            this.resetTemporaryVars();
        }
        catch (error) {
            // ErrorHandler.network(error as any);
            area.name = this.orginalName;
            this.resetTemporaryVars();
        }
    }
    deleteArea(area) {
        this.selectedArea = area;
        this.$store.dispatch('openDialog', this.dialogOptions);
    }
    changeEligibility(area, isIdpEligible) {
        this.selectedArea = area;
        this.isIdpEligible = !this.area.is_idp_eligible;
        this.$store.dispatch('openDialog', this.excludeOptions);
    }
    changeIgnoreStatusDuringPeriodChange(area) {
        this.selectedArea = area;
        this.ignoreStatusDuringPeriodChange = !this.area.ignore_status_during_period_change;
        this.$store.dispatch('openDialog', this.IgnoreStatusDuringPeriodChangeOptions);
    }
    toggleWorksheetGeneration() {
        this.$store.dispatch('openDialog', this.worksheetGenerationDialogOptions);
    }
    getSortedAreaCount(totals) {
        const removeNonIntegers = /^\D+/g;
        return Object.keys(totals).sort((a, b) => {
            return Number(a.replace(removeNonIntegers, '')) - Number(b.replace(removeNonIntegers, ''));
        });
    }
    isExcluded(id) {
        // const excluded = this.userExcludes.find((userExclude: UserPreferences) => {
        //   if (!userExclude.subject) {
        //     return false;
        //   }
        //   return (userExclude.subject === id || (userExclude.subject as any).id === id);
        // });
        // return excluded ? true : false;
        return false;
    }
    handleTopicUpdate(topic) {
        const index = this.topics.findIndex((subject) => subject.id === topic.id);
        if (index < 0) {
            return;
        }
        // this.topics[index].is_idp_eligible = topic.is_idp_eligible;
        this.$set(this.topics, index, topic);
    }
    handleTopicDeleted(topic) {
        const key = this.topics.findIndex((subject) => subject.id === topic.id);
        this.topics.splice(key, 1);
    }
    resetTemporaryVars() {
        this.orginalName = '';
        // this.selectedAreaColor = '';
        // this.selectedAreaIcon = '';
        // this.selectedStatusSet = '';
    }
    handleNewSubject(event) {
        const subject = event.subject;
        subject.children = [];
        this.topics.push(subject);
    }
    fetchAreaCount(area) {
        if (this.hasAreaCount) {
            return;
        }
        this.isFetchingAreaCount = true;
        let levels = [];
        let periods = [];
        let subject_labels = [];
        if (this.filters.levels && this.filters.levels.value && this.filters.levels.value.length) {
            levels = [this.filters.levels];
        }
        if (this.filters.periods && this.filters.periods.value && this.filters.periods.value.length) {
            periods = [this.filters.periods];
        }
        if (this.filters.subject_labels &&
            this.filters.subject_labels.value &&
            this.filters.subject_labels.value.length) {
            subject_labels = [this.filters.subject_labels];
        }
        const filters = {
            curriculum: this.curriculum && this.curriculum.id ? this.curriculum : this.$store.state.curriculum.id,
            levels,
            periods,
            subject_labels,
        };
        new Subject()
            .include('count')
            .filter(filters)
            .find(area.id)
            .then((area) => {
            this.areaCountData = area.count;
            Object.keys(this.areaCountData.topics).forEach((key) => {
                if (!this.areaCountData) {
                    return;
                }
                const topic = {
                    uuid: key,
                    value: this.areaCountData.topics[key],
                };
                this.countData.push(topic);
                this.countDataSubjects += this.areaCountData.topics[key];
            });
            this.isFetchingAreaCount = false;
            this.hasAreaCount = true;
        });
    }
    get user() {
        return this.$store.state.Auth;
    }
    get isTeacherWithExpertRights() {
        return this.user && this.user.isTeacherWithExpertRights();
    }
    get canEnableWorksheet() {
        if (!this.user) {
            return false;
        }
        if (this.isTeacherWithExpertRights) {
            return true;
        }
        return this.user.hasRole([RolesEnum.ROOT, RolesEnum.TRAINER, RolesEnum.MANAGER]);
    }
    fetchAreaCountsChanged(isFetching) {
        if (isFetching) {
            this.fetchAreaCount(this.area);
        }
    }
};
__decorate([
    Prop(),
    __metadata("design:type", typeof (_a = typeof Curriculum !== "undefined" && Curriculum) === "function" ? _a : Object)
], AreaRow.prototype, "curriculum", void 0);
__decorate([
    Prop({ default: new Subject() }),
    __metadata("design:type", typeof (_b = typeof Subject !== "undefined" && Subject) === "function" ? _b : Object)
], AreaRow.prototype, "area", void 0);
__decorate([
    Prop({ default: false }),
    __metadata("design:type", Boolean)
], AreaRow.prototype, "selectable", void 0);
__decorate([
    Prop({ default: false }),
    __metadata("design:type", Boolean)
], AreaRow.prototype, "isCurriculum", void 0);
__decorate([
    Prop({ default: true }),
    __metadata("design:type", Boolean)
], AreaRow.prototype, "hasLink", void 0);
__decorate([
    Prop({ default: () => { } }),
    __metadata("design:type", Object)
], AreaRow.prototype, "filters", void 0);
__decorate([
    Prop({ default: () => [] }),
    __metadata("design:type", Array)
], AreaRow.prototype, "selectedSubjects", void 0);
__decorate([
    Prop({ default: () => { } }),
    __metadata("design:type", Object)
], AreaRow.prototype, "visibility", void 0);
__decorate([
    Prop({ default: false }),
    __metadata("design:type", Boolean)
], AreaRow.prototype, "infoVisible", void 0);
__decorate([
    Prop({ default: false }),
    __metadata("design:type", Boolean)
], AreaRow.prototype, "fetchAreaCounts", void 0);
__decorate([
    Watch('fetchAreaCounts'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], AreaRow.prototype, "fetchAreaCountsChanged", null);
AreaRow = __decorate([
    Component({
        components: {
            TopicRow,
            NewSubjectDialog,
            StatusSetSelect,
        },
    })
], AreaRow);
export default AreaRow;
